import * as React from 'react';
import { connect } from 'react-redux';
import GaranziaActions from './garanzie_actions';
import * as agui from 'arm-gui/dist/controls';

import { Utils, NumberFormatter, isAuth, domainVal, i18n, DateFormatter } from 'arm-common';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { AppConstants } from '../../constants/AppConstants';
import { isNullOrUndefined } from 'util';
import { rejects } from 'assert';
import AppActions from '../../app/app_actions';
import MicroCategoriaTable from '../microCategorie/MicroCategoriaTable.jsx';
import ProdottoActions from '../prodotto/prodotto_actions';
import BtnDelete from '../shared/BtnDelete.jsx'
import ApplicationData from '../../app/aApplicationData'


class GaranziaDetails extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[GaranziaDetails.jsx] ';
        this.modificaButton = this.modificaButton.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteGaranzia = this.deleteGaranzia.bind(this);
        this.nuovoRegimeFiscale = this.nuovoRegimeFiscale.bind(this);
        this.detailsOnClick = this.detailsOnClick.bind(this);
        this.indietroButton = this.indietroButton.bind(this);
        this.searchProdottiOfGaranzia = this.searchProdottiOfGaranzia.bind(this);
        this.inputChangeHandlerProdottoSearch = this.inputChangeHandlerProdottoSearch.bind(this);
        this.detailsOnClickProdotto = this.detailsOnClickProdotto.bind(this);
        this.state = {
            showConfirm: false
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        let idGaranzia = null;

        if (isNullOrUndefined(this.props.location.state) || isNullOrUndefined(this.props.location.state.id)) {
            idGaranzia = this.props.garanzia.id;
        } else {
            idGaranzia = this.props.location.state.id;
        }

        console.log(this.componentName + '[ID] ' + idGaranzia);
        let columns = [
            { field: 'id', title: 'ID ', sortable: 'true' },
            // { field: 'nomeEntity', title: 'Nome', sortable: 'false' },
            // { field: 'idEntity', title: 'Id Entita', sortable: 'true' },
            { field: 'codTipoAliquota', title: i18n('ARM_CORE_PRODUCT.GARANZIE.TIPO_ALIQUOTA', 'Tipo Aliquota'), sortable: 'true', formatter: this.tipoAliquotaFormatter },
            { field: 'valoreAliquota', title: i18n('ARM_CORE_PRODUCT.GARANZIE.VALORE_ALIQUOTA', 'Valore Aliquota'), sortable: 'true', formatter: this.valoreAliquotaFormatter },
            { field: 'updateDate', title: i18n('ARM_CORE_PRODUCT.SHARED.ULTIMA_MODIFICA', 'Ultima Modifica'), sortable: 'true', formatter: this.dateFormatter },
            { field: 'updateUser', title: i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da'), sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
        ];

        $(this.refs.RegimiFiscaliTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            sortOrder: "desc",
            pagination: true,
            onClickRow: (row, $element) => this.detailsOnClick(row, $element),
        });

        //definisco le colonne della boostrap table del Prodotto
        let columnsProdotto = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'nome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), sortable: 'true' },
            { field: 'nomeVersione', title: i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE', 'Versione'), sortable: 'true' },
            { field: 'inizioValidita', title: i18n('ARM_CORE_PRODUCT.SHARED.INIZIO', 'Inizio'), sortable: 'true', formatter: this.dateFormatterShort },
            { field: 'fineValidita', title: i18n('ARM_CORE_PRODUCT.SHARED.FINE', 'Fine'), sortable: 'true', formatter: this.dateFormatterShort },
            { field: 'stato', title: i18n('ARM_CORE_PRODUCT.SHARED.STATO', 'Stato'), sortable: 'true', formatter: this.statoProdottoFormatter },
            { field: 'tipoCopertura', title: i18n('ARM_CORE_PRODUCT.SHARED.TIPO_COPERTURA', 'Tipo Copertura'), sortable: 'true', formatter: this.tipoCoperturaFormatter },
            { field: 'gruppoProdotto.nome', title: i18n('ARM_CORE_PRODUCT.SHARED.MICRO_CATEGORIA', 'Micro-categoria'), sortable: 'true' },
            { field: 'prodottoCmpPojo.compagnia.denominazione', title: i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia'), sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
        ];



        $(this.refs.ProdottoTable).bootstrapTable({
            columns: columnsProdotto,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClickProdotto(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });
        //effettuo la chimata rest per recuperare i dati

        this.props.getGaranziaDetails(idGaranzia).then(
            resolve => {
                this.props.getListaGruppiProdottoConGaranzia().then(
                    resolve => {
                        this.searchProdottiOfGaranzia();
                    }, reject => {
                        console.log(this.componentName + 'getListaGruppiProdottoConGaranzia KO');
                    }
                )
            }, reject => {
                console.log(this.componentName + 'getGaranziaDetails(idGaranzia) KO');
            }
        );
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.garanzia.listRegimi !== this.props.garanzia.listRegimi) {
            console.log("\t rows: " + (nextProps.garanzia.listRegimi !== null ? nextProps.garanzia.listRegimi.length : "NULL"));
            $(this.refs.RegimiFiscaliTable).bootstrapTable('load', nextProps.garanzia.listRegimi);
        }
        // if (nextProps.garanzia.listProdottiOfGaranzia !== this.props.garanzia.listProdottiOfGaranzia) {
        //     console.log("\t rows: " + (nextProps.garanzia.listProdottiOfGaranzia !== null ? nextProps.garanzia.listProdottiOfGaranzia.length : "NULL"));
        //     $(this.refs.ProdottoTable).bootstrapTable('load', nextProps.garanzia.listProdottiOfGaranzia);
        // }
    }


    modificaButton() {
        console.log(this.componentName + 'modificaButton');
        this.props.history.push({
            pathname: '/garanzie/create', state: {
                id: this.props.garanzia.id,
                modifica: true
            }
        })

    }

    inputChangeHandlerProdottoSearch(e) {

        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            console.log(this.componentName + "inputChangeHandlerProdottoSearch:" + id);
            this.props.inputChangeHandlerProdottoSearch(id, value);
        }
    }

    indietroButton() {
        console.log(this.componentName + 'indietroButton');
        if (!isNullOrUndefined(this.props.location.state) && this.props.location.state.goBackOfHistory) {
            this.props.history.goBack();
        } else {
            this.props.history.push({
                pathname: '/garanzie/list',
            })
        }

    }

    showConfirmPanel() {
        this.props.showPopUP(!this.props.showConfirm);
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    deleteGaranzia() {
        console.log(this.componentName + 'deleteGaranzia');
        // this.setState({ showConfirm: false });
        this.showConfirmPanel();

        this.props.deleteGaranzia().then(
            resolve => {

                this.props.history.push({
                    pathname: '/garanzie/list'
                });

            }, reject => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
                console.log(this.componentName + 'deleteGaranzia KO');
            }
        )


    }

    nuovoRegimeFiscale() {
        console.log(this.componentName + "nuovoRegimeFiscale: ");
        this.props.clearRF();
        this.props.history.push({ pathname: '/garanzie/createRF', state: { nomeEntity: "GARANZIA" } });
    }
    columnDetail(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({ pathname: '/garanzie/detailsRF', state: { id: row.id } });
    }

    detailsOnClickProdotto(row, $element, field) {
        console.log(this.componentName + "detailsOnClickProdotto [field] " + field);

        this.props.history.push({ pathname: '/prodotto/details', state: { id: row.id } });
    }

    tipoAliquotaFormatter(value, row, index) {
        console.log(this.componentName + "tipoAliquotaFormatter [field] " + index);
        return ApplicationData.domainVal('AI_TIPO_ALIQUOTA', value, value).desDom;
    }

    valoreAliquotaFormatter(value, row, index) {
        console.log(this.componentName + "valoreAliquotaFormatter [field] " + index);
        let result = '';
        if (value !== undefined && value !== null) {
            result = value;
        } else if (row.valoreAliquotaStr !== undefined && row.valoreAliquotaStr !== null) {
            result = row.valoreAliquotaStr;
        }
        return result;
    }

    searchProdottiOfGaranzia() {
        console.log(this.componentName + ' searchProdottiOfGP');

        this.props.searchProdottiOfGaranzia().then(
            resolve => {
                if (resolve === null) {
                    $(this.refs.ProdottoTable).bootstrapTable('removeAll');
                } else {
                    $(this.refs.ProdottoTable).bootstrapTable('load', resolve);
                }

            },
            reject => {
                console.log(this.componentName + ' searchProdottiOfGaranzia KO');
            }
        )
    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    statoProdottoFormatter(value, row, index) {
        console.log(this.componentName + ' statoProdottoFormatter index: ' + index);

        if (value !== undefined && value !== null) {
            let title = ApplicationData.domainVal('AI_STATO_PRODOTTO', value, value).desDom;
            if (value === 'LAV') {  // lavorazzione
                return "<i class='fas fa-spinner' title='" + title + "'></i>";
            } else if (value === 'PUBB') {  // pubblicato
                return "<i class='far fa-check-circle' title='" + title + "'></i>";
            }
            return " ";
        }

        return '-';
    }

    tipoCoperturaFormatter(value, row, index) {
        console.log(this.componentName + ' tipoCoperturaFormatter index: ' + index);

        if (value !== undefined && value !== null) {
            let descrizione = ApplicationData.domainVal('AI_TIPO_COPERTURA', value, value).desDom;
            return descrizione;
        }

        return '-';
    }


    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="card">
                <div className="card-header">
                    <h3> {i18n('ARM_CORE_PRODUCT.GARANZIE.DETTAGLIO_GARANZIA', 'Dettaglio Garanzia')} {this.props.garanzia.nome} - id {this.props.garanzia.id}</h3>
                </div>
                <div className="card-body">

                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="active" >
                            <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO', 'Dettaglio')}</a>
                        </li>
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.MICRO-CATEGORIE') &&
                            <li className="nav-item">
                                <a className="nav-link" id="gruppiProdotto-tab" data-toggle="tab" href="#gruppiProdotto" role="tab" aria-controls="gruppiProdotto" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.GRUPPI_PRODOTTO', 'Micro-categorie')}</a>
                            </li>
                        }
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTI') &&
                            <li className="nav-item">
                                <a className="nav-link" id="prodotti-tab" data-toggle="tab" href="#prodotti" role="tab" aria-controls="prodotti" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.PRODOTTI', 'Prodotti')}</a>
                            </li>}

                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className='tab-pane active' id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div>
                                <div className="mt-2 mb-2">
                                    {this.props.garanzia ?
                                        <div>
                                            <dl className="row">
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}</dt>
                                                <dd className="col-sm-4 col-6">{this.props.garanzia.nome}</dd>
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.GARANZIE.SIGLA', 'Sigla')}</dt>
                                                <dd className="col-sm-4 col-6">{this.props.garanzia.sigla}</dd>
                                            </dl>
                                            <dl className="row">
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.AI_BISOGNO', 'Bisogno')}</dt>
                                                <dd className="col-sm-4 col-6">{(this.props.garanzia.codBisogno !== null && this.props.garanzia.codBisogno !== undefined) ? ApplicationData.domainVal('AI_BISOGNO', this.props.garanzia.codBisogno, this.props.garanzia.codBisogno).desDom : null}</dd>
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT_RAMO_GARANZIA', 'Ramo Garanzia')}</dt>
                                                <dd className="col-sm-4 col-6">{(this.props.garanzia.codRamo !== null && this.props.garanzia.codRamo !== undefined) ? ApplicationData.domainVal('AI_RAMO_GARANZIA', this.props.garanzia.codRamo, this.props.garanzia.codRamo).desDom : null}</dd>
                                            </dl>

                                            <dl className="row">
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.INSERITO_DA', 'Inserito da')} </dt>
                                                <dd className="col-sm-4 col-6">{this.props.garanzia.insertUser}</dd>
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento')}</dt>
                                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.garanzia.insertDate)}</dd>


                                            </dl>
                                            <dl className="row">
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da')}</dt>
                                                <dd className="col-sm-4 col-6">{this.props.garanzia.updateUser}</dd>
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica')}</dt>
                                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.garanzia.updateDate)}</dd>
                                            </dl>

                                        </div>
                                        :
                                        null
                                    }
                                </div>
                                {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                                    <agui.aButton className="float-left mt-2" bs='primary' onClick={this.nuovoRegimeFiscale} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.GARANZIE.REGIME_FISCALE', 'Regime Fiscale')}</agui.aButton>
                                }
                                <table ref="RegimiFiscaliTable" className={AppConstants.CLASS_TABLE} />
                            </div>

                        </div>
                        <div className="tab-pane fade" id="gruppiProdotto" role="tabpanel" aria-labelledby="gruppiProdotto-tab">
                            <MicroCategoriaTable rows={this.props.garanzia.listaGruppiProdottoConGaranzia} history={this.props.history}></MicroCategoriaTable>
                        </div>
                        <div className="tab-pane fade" id="prodotti" role="tabpanel" aria-labelledby="prodotti-tab">
                            <div className="row mt-5">
                                <div className="col col-sm-4 col-md-4 col-lg-4">
                                    <div className="form-group">
                                        <label htmlFor="dataValidita">  {i18n('ARM_CORE_PRODUCT.SHARED.DATA_VALIDITA', 'Data Validità')} </label>
                                        <input className="form-control" type="date"
                                            onChange={this.inputChangeHandlerProdottoSearch}
                                            value={this.props.psp.dataValidita ? DateFormatter.formatDateFromMilisToString(this.props.psp.dataValidita) : ""}
                                            id="dataValidita" name="dataValidita" />
                                    </div>
                                </div>
                                <div
                                    style={{
                                        marginTop: 30,
                                        marginLeft: 15,
                                    }} >

                                    <agui.aButton className="float-right" bs='primary' onClick={this.searchProdottiOfGaranzia} icon="fas fa-search" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.CERCA', 'Cerca')} </agui.aButton>
                                </div>
                            </div>
                            <table ref="ProdottoTable" className={AppConstants.CLASS_TABLE} />
                        </div>
                    </div>

                </div>
                <div className="card-footer">
                    <div className="float-left">
                        {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                            <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" onClick={this.modificaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                        }
                        {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                            <BtnDelete onClick={this.showConfirmPanel} className="" ></BtnDelete>
                        }
                        {/* <agui.aButton bs="danger" icon="fas fa-trash-alt" onClick={this.showConfirmPanel} >Elimina</agui.aButton> */}
                    </div>
                    <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.indietroButton} >{i18n('ARM_CORE_PRODUCT.SHARED.INDIETRO', 'Indietro')}</agui.aButton>
                </div>
                <ConfirmModalDeleteV4
                    show={this.props.showConfirm}
                    deleteOnClick={this.deleteGaranzia}
                    onClose={this.showConfirmPanel} />
            </div>
        );
    }
};




function mapStateToProps(state, ownProps) {
    return {
        garanzia: state.garanzie.detailsGaranzia,
        showConfirm: state.app.showPopUp,
        psp: state.prodotto.psp
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getGaranziaDetails(id) {
            return dispatch(GaranziaActions.getGaranziaDetails(id));
        },
        deleteGaranzia() {
            return dispatch(GaranziaActions.deleteGaranzia());
        },
        clearRF() {
            return dispatch(GaranziaActions.clearRF())
        },
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },
        getListaGruppiProdottoConGaranzia() {
            return dispatch(GaranziaActions.getListaGruppiProdottoConGaranzia())
        },
        searchProdottiOfGaranzia() {
            return dispatch(GaranziaActions.searchProdottiOfGaranzia());
        },
        inputChangeHandlerProdottoSearch(id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerProdottoSearch(id, value));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GaranziaDetails);



